/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const PlayOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M19.13 11.36 5.64 3.11A.696.696 0 0 0 5.27 3c-.14 0-.27.03-.39.1-.11.06-.21.16-.28.27-.06.12-.1.25-.1.38v16.5c0 .13.04.26.1.38.07.11.17.21.28.27.12.07.25.1.39.1.13 0 .26-.04.37-.11l13.49-8.25c.12-.07.21-.16.27-.27s.1-.24.1-.37-.04-.26-.1-.37-.15-.2-.27-.27z"
})));
// Fill
const PlayFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M19.53 10.72 6.03 2.48c-.23-.15-.49-.23-.75-.23-.27-.01-.53.06-.76.2-.23.13-.43.31-.56.54-.14.23-.21.49-.21.76v16.5c0 .27.07.53.21.76.13.23.33.42.56.54.23.14.49.21.76.2.26 0 .52-.08.75-.22l13.5-8.25c.22-.13.4-.32.53-.54.13-.23.19-.48.19-.74s-.06-.51-.19-.74c-.13-.22-.31-.41-.53-.54z"
})));
// DuoTone
const PlayDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M19.13 11.36 5.64 3.11A.696.696 0 0 0 5.27 3c-.14 0-.27.03-.39.1-.11.06-.21.16-.28.27-.06.12-.1.25-.1.38v16.5c0 .13.04.26.1.38.07.11.17.21.28.27.12.07.25.1.39.1.13 0 .26-.04.37-.11l13.49-8.25c.12-.07.21-.16.27-.27s.1-.24.1-.37-.04-.26-.1-.37-.15-.2-.27-.27z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M19.13 11.36 5.64 3.11A.696.696 0 0 0 5.27 3c-.14 0-.27.03-.39.1-.11.06-.21.16-.28.27-.06.12-.1.25-.1.38v16.5c0 .13.04.26.1.38.07.11.17.21.28.27.12.07.25.1.39.1.13 0 .26-.04.37-.11l13.49-8.25c.12-.07.21-.16.27-.27s.1-.24.1-.37-.04-.26-.1-.37-.15-.2-.27-.27h0z"
})));
/**
  Icon PlayIcon in media group
*/
export const PlayIcon = createIcon('PlayIcon', 'play', 'media', PlayOutline, PlayFill, PlayDuotone, "0 0 24 24");